import { HasId } from '../interfaces';
import { User, Style } from '../models';

export class UserStyle implements HasId {
    public id: number;
    public userID: number;
    public user: User;
    public style: Style;
    public styleID: number;
    public overridden: boolean;
}


// WEBPACK FOOTER //
// ./src/models/UserStyle.tsx